import { render, staticRenderFns } from "./TimeAllocationForm.vue?vue&type=template&id=46eb81f8&scoped=true"
import script from "./TimeAllocationForm.vue?vue&type=script&lang=js"
export * from "./TimeAllocationForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46eb81f8",
  null
  
)

export default component.exports